module.exports = __webpack_public_path__ + "img/sortIcon.997b797d.svg";